import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../services/user.service';
import { HelpersService } from '../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BroadcastService } from '../../../../services/broadcast.service';

@Component({
  selector: 'app-switch-shop',
  templateUrl: './switch-shop.component.html',
  styleUrls: ['./switch-shop.component.scss'],
})
export class SwitchShopComponent implements OnInit {
  public partners: any = [];
  public partnerID: number = 0;
  public loading: boolean = false;
  public columns: any = [
    {
      header: this.translate.instant('bikeshop.switch_shop.shops'),
      field: 'Name',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.switch_shop.phone_number'),
      field: 'PhoneNumber1',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.switch_shop.email'),
      field: 'eMail',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.switch_shop.country'),
      field: 'Country',
      type: 'string',
    },
  ];

  constructor(
    private userService: UserService,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private router: Router,
    private broadcastService: BroadcastService,
  ) {}

  ngOnInit() {
    this.partnerID = this.helpersService.getPartnerId();
    this.getAllMyShops();
  }

  getAllMyShops() {
    this.loading = true;
    this.userService.getConnectedBikeShops().subscribe((partners) => {
      this.partners = partners;
      this.loading = false;
    });
  }

  switchShop(partner) {
    //Point at the new store FIRST: getPartnerId() reads PartnerID off this same
    //profile blob, and clearTenantScopedCache() must not touch it.
    var profile = this.helpersService.getProfileData();
    profile.PartnerID = partner.ID;
    this.helpersService.saveProfileData(profile);

    this.helpersService.clearTenantScopedCache();

    //Park on the vertical-neutral spinner route and let PortalComponent resolve the
    //vertical from the new store's subscriptions. Navigating straight to
    //store/calendar assumed Workshop before any of the new store's data had loaded.
    this.broadcastService.sendMessage({ partner: { switchPartner: true } });
    this.router.navigateByUrl('store/product-redirect-loader');
  }
}
